var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_3475)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_3475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7151 6.28558C17.7151 4.77005 17.1131 3.3166 16.0415 2.24497C14.9698 1.17333 13.5164 0.571289 12.0008 0.571289C10.4853 0.571289 9.03187 1.17333 7.96023 2.24497C6.8886 3.3166 6.28656 4.77005 6.28656 6.28558H0.572266V20.5713C0.572266 21.3291 0.873285 22.0558 1.4091 22.5916C1.94492 23.1274 2.67165 23.4284 3.42941 23.4284H20.5723C21.33 23.4284 22.0568 23.1274 22.5926 22.5916C23.1284 22.0558 23.4294 21.3291 23.4294 20.5713V6.28558H17.7151ZM12.0008 2.47605C13.0112 2.47605 13.9802 2.87741 14.6946 3.59184C15.409 4.30626 15.8104 5.27523 15.8104 6.28558H8.19132C8.19132 5.27523 8.59268 4.30626 9.3071 3.59184C10.0215 2.87741 10.9905 2.47605 12.0008 2.47605ZM21.5247 20.5713C21.5247 20.8239 21.4243 21.0661 21.2457 21.2447C21.0671 21.4233 20.8249 21.5237 20.5723 21.5237H3.42941C3.17682 21.5237 2.93458 21.4233 2.75598 21.2447C2.57737 21.0661 2.47703 20.8239 2.47703 20.5713V8.19034H6.28656V10.0951H8.19132V8.19034H15.8104V10.0951H17.7151V8.19034H21.5247V20.5713Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_3475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8571,
    height: 22.8571,
    fill: "white",
    transform: "translate(0.572266 0.571289)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_3475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8572,
    height: 22.8572,
    fill: "white",
    transform: "translate(0.572266 0.571289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.6cb4bb930ba28e562e1c1d97fda1b10f.svg";
export { ForwardRef as ReactComponent };